const UNIT_SECONDS = { y: 31536000, mo: 2592000, d: 86400, h: 3600, m: 60 };
const MAX_DAYS = 99;

// Re-formats the "7mo 6d" style string returned by evaluateSLAStatus into
// "6h 20m" / "3d 4h" / "215d", capped at "+99d".
export const formatSlaTime = value => {
  if (!value) return value;
  const seconds = value.split(' ').reduce((sum, part) => {
    const [, amount, unit] = part.match(/^(\d+)(\D+)$/);
    return sum + Number(amount) * UNIT_SECONDS[unit];
  }, 0);

  const days = Math.floor(seconds / UNIT_SECONDS.d);
  if (days > MAX_DAYS) return `+${MAX_DAYS}d`;

  const hours = Math.floor((seconds % UNIT_SECONDS.d) / UNIT_SECONDS.h);
  const minutes = Math.floor((seconds % UNIT_SECONDS.h) / UNIT_SECONDS.m);
  if (days >= 10) return `${days}d`;
  if (days > 0) return hours ? `${days}d ${hours}h` : `${days}d`;
  if (hours > 0) return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
  return `${minutes}m`;
};
